import React from 'react';

import { TagColored } from 'uiToolkitV1/Tag';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const calcReviewStatusFromCount = ({ submitted = 0, total = 0 }) => {
  if (total === 0) {
    return {
      color: 'black',
      label: 'NA',
    };
  }

  const isNotStarted = submitted === 0;
  const isCompleted = submitted === total;

  return {
    // eslint-disable-next-line no-nested-ternary
    color: isCompleted ? 'green' : isNotStarted ? 'grey' : 'yellow',
    // eslint-disable-next-line no-nested-ternary
    label: isCompleted ? 'Completed' : isNotStarted ? 'Not Started' : 'In Progress',
  };
};

const ReviewStatusV1 = ({ cellData }) => {
  const submitted = cellData?.value.submitted;
  const total = cellData?.value.total;

  if (total === 0) {
    return <TextBodyMedium>NA</TextBodyMedium>;
  }

  const { color, label } = calcReviewStatusFromCount({ submitted, total });

  return (
    // eslint-disable-next-line no-nested-ternary
    <TagColored color={color}>
      {label}:{submitted}/{total}
    </TagColored>
  );
};

const reviewStatusValueGetterCSV = (value) => {
  const submitted = value?.submitted;
  const total = value?.total;

  if (total === 0) {
    return 'NA';
  }
  return `Completed : ${submitted}/${total}`;
};

export { ReviewStatusV1, reviewStatusValueGetterCSV };
